class FormValidator {
  #name;
  #callback;
  #error;

  constructor(callback, error, name = '') {
    this.#callback = callback;
    this.#error = error;
    this.#name = name;
  }

  get name() {
    return this.#name;
  }

  get errorMessage() {
    return this.#error;
  }

  getIsValid(value) {
    return this.#callback(value);
  }
}

export default FormValidator;
